'use client';

import { ArrowPathIcon } from '@heroicons/react/24/outline';
import type { LucideIcon } from 'lucide-react';
import { SectionPanel } from './SectionPanel';

export type SectionLoadingSkeletonProps = {
  title: string;
  description: React.ReactNode;
  icon?: LucideIcon;
};

export function SectionLoadingSkeleton({
  title,
  description,
  icon,
}: SectionLoadingSkeletonProps) {
  return (
    <SectionPanel
      title={title}
      icon={icon}
      bleedOnMobile
      description={description}
      trailing={
        <ArrowPathIcon className="h-3.5 w-3.5 animate-spin text-muted-foreground" />
      }
    >
      <div className="relative h-0.5 w-full overflow-hidden bg-muted">
        <div
          className="absolute h-full w-1/4 bg-[var(--burgundy-core)]"
          style={{ animation: 'progress-slide 1.6s ease-in-out infinite' }}
        />
      </div>
    </SectionPanel>
  );
}
